module.exports = __webpack_public_path__ + "media/images/flags/sb-c40fc3f74ac9736c3844f6b8120a249a.svg";